import React from "react";
import "./BusinessModel.css";
import Iconify from "@iconify/iconify";
const BusinessModel = () => {
  return (
    <>
      <section className="servicesSec-v4 busyModel-v4 py-5">
        <div className="container">
          
          {/* Section Header */}
          <div className="section-header-v4 text-center mb-5" data-wow-duration="1.1s">
            <h3 className="section-title-v4">Our Business Model</h3>
            <div className="title-separator-v4 mx-auto"></div>
          </div>

          {/* Intro Description */}
          <div className="row mb-5">
            <div className="col-lg-10 mx-auto text-center">
              <p className="lead-text-v4">
                We are working hard towards automation where every products or
                services are being transacted in auto mode with the help of
                technology. Since the Company is in B2B module, it is very
                selective towards selecting the Platforms or modules before
                entering into competitive era. DMT has the following platform to
                make available the Products & Services to the Market.
              </p>
            </div>
          </div>

          {/* Premium Modern Tab Structure */}
          <div className="row pt-2 pb-4">
            <div className="col-12">
              <div className="tabs-container-v4">
                <ul className="nav nav-tabs custom-nav-tabs-v4 justify-content-center" id="myTab" role="tablist">
                  
                  <li className="nav-item tab-item-v4" role="presentation">
                    <button
                      className="nav-link tab-link-v4 active"
                      id="home-tab"
                      data-bs-toggle="tab"
                      data-toggle="tab"
                      data-bs-target="#home"
                      href="#home"
                      role="tab"
                      aria-controls="home"
                      aria-selected="true"
                    >
                      <div className="tab-icon-wrapper-v4 icon-purple-v4">
                        <i className="iconify" data-icon="mdi:store"></i>
                      </div>
                      <span className="tab-label-v4">Retail Model</span>
                    </button>
                  </li>

                  <li className="nav-item tab-item-v4" role="presentation">
                    <button
                      className="nav-link tab-link-v4"
                      id="profile-tab"
                      data-bs-toggle="tab"
                      data-toggle="tab"
                      data-bs-target="#profile"
                      href="#profile"
                      role="tab"
                      aria-controls="profile"
                      aria-selected="false"
                    >
                      <div className="tab-icon-wrapper-v4 icon-indigo-v4">
                        <i className="iconify" data-icon="typcn:group-outline"></i>
                      </div>
                      <span className="tab-label-v4">Distribution Model</span>
                    </button>
                  </li>

                  <li className="nav-item tab-item-v4" role="presentation">
                    <button
                      className="nav-link tab-link-v4"
                      id="contact-tab"
                      data-bs-toggle="tab"
                      data-toggle="tab"
                      data-bs-target="#contact"
                      href="#contact"
                      role="tab"
                      aria-controls="contact"
                      aria-selected="false"
                    >
                      <div className="tab-icon-wrapper-v4 icon-emerald-v4">
                        <i className="iconify" data-icon="mdi:devices"></i>
                      </div>
                      <span className="tab-label-v4">White-Label Model</span>
                    </button>
                  </li>

                  <li className="nav-item tab-item-v4" role="presentation">
                    <button
                      className="nav-link tab-link-v4"
                      id="Franchise-tab"
                      data-bs-toggle="tab"
                      data-toggle="tab"
                      data-bs-target="#Franchise"
                      href="#Franchise"
                      role="tab"
                      aria-controls="Franchise"
                      aria-selected="false"
                    >
                      <div className="tab-icon-wrapper-v4 icon-amber-v4">
                        <i className="iconify" data-icon="mdi:home-modern"></i>
                      </div>
                      <span className="tab-label-v4">Franchise-Label Model</span>
                    </button>
                  </li>

                </ul>
              </div>
            </div>
          </div>

          {/* Content Presenter Display Layers */}
          <div className="tab-content dynamic-tab-content-v4" id="myTabContent">
            
            {/* Tab Panel 1: Retail Model */}
            <div
              className="tab-pane fade show active premium-pane-v4"
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <div className="row align-items-center gy-4">
                <div className="col-md-4 text-center animated fadeInLeft">
                  <div className="img-glow-wrapper-v4">
                    <img
                      src={require("../../static/img/businessModel/retailShop.png")}
                      alt="Retail Model"
                      className="img-fluid model-showcase-img-v4"
                    />
                  </div>
                </div>
                <div className="col-md-8 ps-md-5 animated fadeInRight">
                  <h4 className="modelHead-v4"><span className="highlight-bar-v4 bg-purple-v4"></span>Retail Model</h4>
                  <p className="model-desc-v4">
                    A Retail business model of DMT has been developed in a way which evolves with
                    changes in the business environment, and the value proposition
                    continues to be aligned with the needs of consumers. The
                    retailer should also leverage opportunities that the operating
                    model provides to create differentiating features in its value
                    proposition. The associated retailors can fulfil all the
                    customer’s requirements by using DMT platform.
                  </p>
                </div>
              </div>
            </div>

            {/* Tab Panel 2: Distribution Model */}
            <div
              className="tab-pane fade premium-pane-v4"
              id="profile"
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div className="row align-items-center gy-4">
                <div className="col-md-8 pe-md-5 order-2 order-md-1 animated fadeInRight">
                  <h4 className="modelHead-v4"><span className="highlight-bar-v4 bg-indigo-v4"></span>Distribution Model</h4>
                  <p className="model-desc-v4">
                    DMT has adopted the Conventional distribution model for our
                    distributors where you can make more out of the distribution
                    business. We ask you to onboard your existing and new network
                    to us and earn more than 24% per month on the money invested.
                    No physical stocks and expenditure in-store space, staff or
                    physical transfer of goods are required. Every time a retailer
                    in your network does a transaction and both Distributor and
                    Retailer makes money.
                  </p>
                </div>
                <div className="col-md-4 text-center order-1 order-md-2 animated fadeInLeft">
                  <div className="img-glow-wrapper-v4">
                    <img
                      src={require("../../static/img/businessModel/distribution.png")}
                      alt="Distribution Model"
                      className="img-fluid model-showcase-img-v4"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Tab Panel 3: White-Label Model */}
            <div
              className="tab-pane fade premium-pane-v4"
              id="contact"
              role="tabpanel"
              aria-labelledby="contact-tab"
            >
              <div className="row align-items-center gy-4">
                <div className="col-md-4 text-center animated fadeInLeft">
                  <div className="img-glow-wrapper-v4">
                    <img
                      src={require("../../static/img/businessModel/franchise.png")}
                      alt="Franchise Model"
                      className="img-fluid model-showcase-img-v4"
                    />
                  </div>
                </div>
                <div className="col-md-8 ps-md-5 animated fadeInRight">
                  <h4 className="modelHead-v4"><span className="highlight-bar-v4 bg-emerald-v4"></span>Franchise Model</h4>
                  <p className="model-desc-v4">
                    DMT Group has built its 5+ years success around its Franchisees –
                    independent business owners with a common vision and mission
                    India’s leading B2B aggregator for Travel, Financial
                    inclusion, Telecom & Insurance. Much of this success has come
                    from our franchise business model. Follow the path of more
                    than 95% of our franchise owners and learn to run and operate
                    a store or supervise multiple stores, before investing in your
                    own stores.
                  </p>
                </div>
              </div>
            </div>

            {/* Tab Panel 4: Franchise-Label Model */}
            <div
              className="tab-pane fade premium-pane-v4"
              id="Franchise"
              role="tabpanel"
              aria-labelledby="Franchise-tab"
            >
              <div className="row align-items-center gy-4">
                <div className="col-md-8 pe-md-5 order-2 order-md-1 animated fadeInRight">
                  <h4 className="modelHead-v4"><span className="highlight-bar-v4 bg-amber-v4"></span>White-Label Model</h4>
                  <p className="model-desc-v4">
                    DMT offers B2B white label portal that allows you to connect with other
                    associations from your network and allow them to make
                    transaction of Travel, Banking, Insurance, Utility and many
                    more services to their customers simply and quickly. They can
                    also manage all their day to day financial transactions online
                    and run numerous reports to aid the smooth running of their
                    business.
                  </p>
                </div>
                <div className="col-md-4 text-center order-1 order-md-2 animated fadeInLeft">
                  <div className="img-glow-wrapper-v4">
                    <img
                      src={require("../../static/img/businessModel/whiteLabel.png")}
                      alt="White Label Model"
                      className="img-fluid model-showcase-img-v4"
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default BusinessModel;